// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-filled-TJ6Cgp{color:#ffcc12;width:100%}.icon-stroked-fuKtRz{color:rgba(29,28,35,.35);width:100%}.show-ani-fD8sqq{animation-name:ani-x4fURs;animation-duration:.6s}.show-btn-j0jowu.icon-stroked-fuKtRz{width:100%;color:var(--coz-fg-primary)}@keyframes ani-x4fURs{0%{transform:scale(0)}38%{transform:scale(1.11)}64%{transform:scale(.99)}74%,to{transform:scale(1)}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon-filled": `icon-filled-TJ6Cgp`,
	"iconFilled": `icon-filled-TJ6Cgp`,
	"icon-stroked": `icon-stroked-fuKtRz`,
	"iconStroked": `icon-stroked-fuKtRz`,
	"show-ani": `show-ani-fD8sqq`,
	"showAni": `show-ani-fD8sqq`,
	"ani": `ani-x4fURs`,
	"show-btn": `show-btn-j0jowu`,
	"showBtn": `show-btn-j0jowu`
};
export default ___CSS_LOADER_EXPORT___;
